import { tracker } from './GtagDataLayerHelper';

const targets = Array.from(document.querySelectorAll<HTMLElement>('.js-gtag'));

const components = Array.from(document.querySelectorAll<HTMLElement>('.js-card-impression'));

const forms = Array.from(document.querySelectorAll<HTMLElement>('.js-form-gtag'));

const measurementID = targets[0]?.dataset.msrId;
const transportUrl = targets[0]?.dataset.msrTransportUrl;

if (measurementID && transportUrl) {
  if (targets.length) {
    import('./Gtag').then(({ default: Gtag }) => {
      targets.map((x) => new Gtag(x).init(tracker));
    });
  }

  if (components.length) {
    import('./Components').then(({ default: Components }) => {
      components.map((x, index) => new Components(x, index).init());
    });
  }

  if (forms.length) {
    import('./Form').then(({ default: Form }) => {
      targets.map((x) => new Form(x).init());
    });
  }

  if (typeof window !== undefined) {
    import('./UncaughtErrors').then(({ default: UncaughtError }) => {
      new UncaughtError().init(tracker);
    });
  }
}

export {};
